import { Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TextFilterOperator } from "components/shared/filters";

import { MutableRefObject, useEffect, useState } from "react";
import { GridApi, GridRenderCellParams, GridTreeNodeWithRender } from "@mui/x-data-grid-pro";
import { WorkItemStatuses } from "../fields/WorkItemStatuses";
import { useNavigate } from "react-router-dom";

const useWorkItemResourcesColumnsv2 = (onChange: (changeType: string, params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>, event: any) => void, apiRef: MutableRefObject<GridApi>, WorkItemPermissions: any, wave4Enabled: boolean) => {
  const navigate = useNavigate();

  const columnBase: GridColDef[] = [
    {
      field: 'resources',
      valueGetter: (value, row) => row.resource,
      sortComparator: (r1, r2) => {
        var returnValue = r2.userName.localeCompare(r1.userName);
        return returnValue;
      },
      headerName: 'Resource',
      width: 200,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false,
      renderCell: (params) => {
        return (<>
          {params.row.resource && params.row.resource.userName}
        </>);
      }
    },
    {
      field: 'responsibilityName',
      headerName: 'Responsibility',
      width: 200,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false
    },
    {
      field: 'resource',
      sortComparator: (r1, r2) => r2.isDefaultAssignee - r1.isDefaultAssignee,
      headerName: 'Primary?',
      width: 120,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false,
      renderCell: (params) => {
        let blankUser = (params.row.resource.userName === null || params.row.resource.userName === undefined || params.row.resource.userName === "");
        return (<>
          {blankUser ? "" : params.row.resource.isDefaultAssignee ? 'Primary' : 'Secondary'}
        </>);
      }
    },
    {
      field: 'workItemInstanceId',
      headerName: 'Work Item ID',
      width: 160,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false
    },
    {
      field: 'workItemInstanceName',
      headerName: 'Work Item Name',
      flex: 1,
      minWidth: 250,
      sortable: true,
      resizable: true,
      hideable: false,
      headerClassName: 'header',
      hideSortIcons: false,
      disableReorder: true,
      filterOperators: TextFilterOperator,
      renderCell: (params) => {
        const name = params.row.workItemInstanceName;
        const workItemId = params.row.workItemInstanceId;
        const handleWorkItemClick = (id: any) => {
          if (!!wave4Enabled) {
            navigate(`/workitems/${workItemId}/overview`);
          }
          else {
            navigate(`external?url=/workitemenduser/editworkitem?workitemId=${workItemId}`);
          }
        }
        return (
          <Tooltip title={name} arrow>
            <div>
              <a
                onClick={() => handleWorkItemClick(workItemId)}
                style={{ color: '#0066CC', cursor: 'pointer', textDecoration: 'underline' }}
                rel="noopener noreferrer">
                {name}
              </a>
            </div>
          </Tooltip>
        );
      }
    },
    {
      field: 'workItemStatusId',
      headerName: 'Work Item Status',
      width: 180,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false,
      renderCell: (params) => {
        const workItemStatusId = params.row.workItemStatusId;
        const workItemStatus = (WorkItemStatuses.find(status => status.value === workItemStatusId))?.label;
        return (
          <>
            {workItemStatus ?? params.row.workItemStatusName}
          </>
        );
      }
    },
    {
      field: 'contentTypeName',
      headerName: 'Content type',
      width: 150, sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false
    },
    {
      field: 'workspaceInstanceName',
      headerName: 'Workspace',
      width: 150,
      sortable: true,
      resizable: true,
      hideable: true,
      headerClassName: 'header',
      hideSortIcons: false
    }
  ];

  const [columns, setColumns] = useState<GridColDef[]>(columnBase);

  useEffect(() => {
    let newColumns: GridColDef[] = [];
    newColumns.push(...columnBase);
    setColumns(newColumns);
  }, [wave4Enabled]);

  return columns;
};

export default useWorkItemResourcesColumnsv2;